import { Box, Paper, Typography } from '@mui/material';
import PropTypes from 'prop-types';

const pageFrameSx = {
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  px: 2,
  py: 4,
};

const paperSx = { maxWidth: 460, width: '100%', p: 4 };

function AuthActionStatus({
  heading, body, note, detail, footer,
}) {
  return (
    <Box sx={pageFrameSx}>
      <Paper elevation={2} sx={paperSx} role="status">
        <Typography variant="h5" component="h1" gutterBottom align="center">
          {heading}
        </Typography>
        <Typography variant="body1" align="center" sx={{ mt: 1 }}>
          {body}
        </Typography>
        {note ? (
          <Typography variant="body1" align="center" sx={{ mt: 1 }}>
            {note}
          </Typography>
        ) : null}
        {detail ? (
          <Typography variant="body1" align="center" sx={{ mt: 1, overflowWrap: 'anywhere' }}>
            {detail}
          </Typography>
        ) : null}
        {footer}
      </Paper>
    </Box>
  );
}

AuthActionStatus.propTypes = {
  heading: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  note: PropTypes.string,
  detail: PropTypes.string,
  footer: PropTypes.node,
};

export default AuthActionStatus;
